import cx from "classnames";

import "./LoadingSpinner.scss";

type LoadingSpinnerProps = {
  size?: "sm" | "md" | "xs";
  color?: string;
};

export const LoadingSpinner = ({ size = "md", color = "#1E1F36" }: LoadingSpinnerProps) => {
  const classes = cx("LoadingSpinner", {
    "LoadingSpinner--Smaller": size === "xs",
    "LoadingSpinner--Small": size === "sm",
    "LoadingSpinner--Medium": size === "md",
  });

  const style = color
    ? ({ "--spinner-color": color } as React.CSSProperties)
    : undefined;

  return (
    <div className={classes} style={style}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};
